export enum MemberStatusId {
  Added = 1,
  Invited,
  Enrolled,
  OptedOut,
  Removed,
}